import { UAParser } from 'ua-parser-js';

/**
 * 动态加载JS
 * @param {string} url 脚本地址
 * @param {function} callback  回调函数
 */
export function dynamicLoadJs(url, callback) {
  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  if (typeof callback == 'function') {
    script.onload = script.onreadystatechange = function () {
      if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
        callback();
        script.onload = script.onreadystatechange = null;
      }
    };
  }
  head.appendChild(script);
}

/**
 * 动态加载CSS
 * @param {string} url 样式地址
 */
export function dynamicLoadCss(url) {
  const head = document.getElementsByTagName('head')[0];
  const link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = url;
  head.appendChild(link);
}

// 获取 query 参数
export function _getLocationQuery(queryString = window.location.search.substring(1)) {
  const query = {};
  // let queryString = ;
  const regex = /([^&=]+)=([^&]*)/g;
  let m;
  while ((m = regex.exec(queryString))) {
    query[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
  }
  return query;
}
export function _getQuery(url) {
  try {
    if (!url) {
      throw 'url 为空';
    }
    const _URL = new URL(url);
    return _URL;
  } catch (error) {
    console.error('ERROR:: _getQuery', error);
    return {};
  }
}

/**
 * 生成 url query
 * @param {String} query
 * @returns String
 * @description 返回值自带 ? 前缀
 */
export function _genQuery(query) {
  let q = '';
  Object.entries(query).forEach(([key, value], index) => {
    q += `${index === 0 ? '?' : '&'}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  });
  return q;
}

// 是否是 iframe
export function _isIframe() {
  try {
    return !!(window && window !== window.top);
  } catch (e) {
    return false;
  }
}

//获取 UA
export function _getUA() {
  if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') {
    return navigator['userAgent'];
  } else {
    return '';
  }
}

// 是否是 安卓
export function _isAndroid(ua = _getUA()) {
  return /android/i.test(ua);
}

/* Storage */
const _query = _getLocationQuery();
const storageSuffix = _query.state || 'XD-LOGIN';
export function _setStorage(key, value) {
  if (typeof value === 'object') {
    value = JSON.stringify(value);
  }
  localStorage.setItem(storageSuffix + '-' + key, value);
}
export function _getStorage(key) {
  return localStorage.getItem(storageSuffix + '-' + key);
}

/* 调用回环地址 */
export function _sendXHRUseScript(url, data, callback) {
  let queryString = '';
  for (const key in data) {
    queryString += key + '=' + data[key] + '&';
  }
  const script = document.createElement('script');
  script.src = url + '?' + queryString;
  document.body.appendChild(script);
  script.onload = function () {
    document.body.removeChild(script);
    callback(null);
  };
  script.onerror = function () {
    document.body.removeChild(script);
    callback('error');
  };
}

/* 国内手机号验证 */
export const REGEXP_PHONE_CN = /^1[3456789]\d{9}$/;
/* 是否是移动端 */
export function _isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function getUA() {
  if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') {
    return navigator['userAgent'];
  } else {
    return '';
  }
}
export function _isIOS(ua = getUA()) {
  return /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && /mobile/i.test(ua));
}
export function _isWebOS(ua = getUA()) {
  return /webos/i.test(ua);
}
export function _isBlackBerry(ua = getUA()) {
  return /blackberry/i.test(ua);
}
export function _isIEMobile(ua = getUA()) {
  return /iemobile/i.test(ua);
}
export function _isMobileBrowser(ua = getUA()) {
  return (
    _isIOS(ua) || _isAndroid(ua) || _isWebOS(ua) || _isBlackBerry(ua) || /windows phone/i.test(ua) || _isIEMobile(ua)
  );
}
export function _isWechatBrowser(userAgent = getUA()) {
  return /micromessenger/i.test(userAgent);
}

/* 获取系统信息 */
export function getOS() {
  const parser = new UAParser();
  const name = parser.getOS().name;
  const version = parser.getOS().version;
  // switch (name) {
  //   case 'Mac OS':
  //     name = 'macOS';
  // }
  return { name, version };
}

/* 获取浏览器信息 */
export function getBrowser() {
  const parser = new UAParser();
  return parser.getBrowser();
}

export function base64Encode(str) {
  return btoa(unescape(encodeURIComponent(str)));
}

export function base64Decode(str) {
  return decodeURIComponent(escape(atob(str)));
}

export function useIntervalTimer(callback, interval) {
  let timeoutId = null;

  const start = () => {
    callback();
    timeoutId = setTimeout(start, interval);
  };

  const stop = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  start();
  return { stop };
}

/**
 * @param {Function} fn
 * @param {Object} options
 * @param {number} [options.delay=500] -
 * @param {boolean} [options.immediate=false]
 * @returns {Function}
 *
 * @example
 * const debouncedFn = debounce(fn, { delay: 1000, immediate: true });
 */
export function debounce(fn, options = {}) {
  const { delay = 500, immediate = false } = options;
  let timer = null;

  let immediateCalled = false;
  return function () {
    if (immediate && !timer) {
      fn.apply(this, arguments);
      immediateCalled = true;
    }

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      if (!immediateCalled) {
        fn.apply(this, arguments);
      }
      immediateCalled = false;
      timer = null;
    }, delay);
  };
}

/**
 * @param {Function} fn
 * @param {Object} options
 * @param {number} [options.delay=500] - 延迟时间
 * @param {boolean} [options.trailing=false] - 是否在最后一次触发后也执行
 * @param {boolean} [options.immediate=true] - 是否立即执行第一次调用
 * @returns {Function}
 *
 * @example
 * const throttledFn = throttle(fn, { delay: 1000, trailing: true, immediate: false });
 */
export function throttle(fn, options = {}) {
  const { delay = 500, trailing = false, immediate = true } = options;
  let lastCall = immediate ? 0 : Date.now();
  let timer = null;

  return function () {
    const now = Date.now();

    if (now - lastCall >= delay) {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }

      lastCall = now;
      fn.apply(this, arguments);
    } else if (trailing && !timer) {
      timer = setTimeout(() => {
        lastCall = Date.now();
        timer = null;
        fn.apply(this, arguments);
      }, delay - (now - lastCall));
    }
  };
}
